module.exports = __webpack_public_path__ + "static/media/Rectangle 12899.61c91748.png";